import * as yup from 'yup';


export const committeeMinutesSchema = yup.object({
    date: yup.date().nullable().typeError('Action date is required').required('Action date is required'),
    agendaItems: yup.array().min(1, 'At least one agenda item is required').required('At least one agenda item  is required'),
    attendees: yup.array().min(1, 'At least one attendee is required').required('At least one attendee is required'),
    apologies: yup.array().test("apologiesTest", "Committee Member cannot be present in both Attendees and Apologies", function (value) {
        let testResult: boolean = true;
        if(this.parent.attendees != null){
            this.parent.attendees.forEach((item: number) => {
                if(value != null && value.includes(item))
                testResult = false;
            })
        }
        return testResult;
      })
});